module.exports = __webpack_public_path__ + "img/2_05.bafa0db8.jpg";